import createIsSubmitting from './selectors/isSubmitting';
import plain from './structure/plain';
export default createIsSubmitting(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/isSubmitting.js
// module id = dI73
// module chunks = 1